import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFlattrComponent } from './simple-icons-flattr.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFlattrComponent ],
    exports:      [ SimpleIconsFlattrComponent ],
    bootstrap:    []
})
export class SimpleIconsFlattrModule {}
